<!--
  메인배너 스와이퍼 컴포넌트
-->
<template>
  <section class="section_home banner" data-effect-slide="scroll">
    <div v-if="bannerData && bannerData.length > 0" class="inner">
      <div :id="idPrefix + bannerId" class="banner_wrapper">
        <div class="banner_content">

          <!-- 배너 리스트 -->
          <div
            ref="mmpMainBanner"
            :class="['wrap_banner_list', 'banner_' + slidesPerView, {'swiper-container' : swiper.isSwiper}]"
          >
            <div :class="['inner', {'swiper-wrapper' : swiper.isSwiper}]">
              <div
                v-for="(item, index) in bannerData"
                :key="item.potltBannSno"
                :data-swiper-slide-index="index"
                :class="['banner_list', { 'swiper-slide': swiper.isSwiper }, { light_bg: $utils.isLightColor(item.bgColorCd) }]"
              >
                <!--                :style="`background-color: ${slidesPerView === 1 && item.bgColorCd}`"-->
                <a
                  :style="!isDesktop || (isDesktop && slidesPerView === 1) ? `background-color:${item.bgColorCd}` : `background-color:transparent`"
                  href="javascript:void(0)"
                  class="banner_link"
                >
                  <img
                    :src="isDesktop ? item.imgPc : item.imgMo"
                    :alt="item.title"
                    class="banner_img"
                  >
                </a>
              </div>
            </div>
          </div>
          <!-- // 배너 리스트 -->

          <!-- swiper navigation -->
          <!--          <div v-if="shouldShowSwiperNav" class="swiper_nav">-->
          <div
            v-if="swiper.isSwiper"
            ref="swiperNavigation"
            class="swiper_nav"
          >
            <div class="swiper-button-prev" />
            <div class="swiper-button-next" />
          </div>
          <!-- // swiper navigation -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import commonMixin from '@/mixin/commonMixin'
import 'swiper/dist/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import MotionEffects from '@/assets/js/MotionEffects'

export default {
  name: 'BandBanner',
  components: {
    Swiper,
    SwiperSlide
  },
  mixins: [commonMixin, MotionEffects],
  props: {
    potltInfo: {
      type: Object,
      default: null
    },
    // 캠페인 ID
    bannerId: {
      type: [String, Number],
      default: ''
    },
    slidesPerView: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      idPrefix: 'banner_', // wrapper ID 앞에 추가되는 고정 값 (id="banner_'캠페인 ID''")
      bannerData: null, // 배너 데이터
      // 스와이퍼 옵션
      swiper: {
        instance: null, // 스와이퍼 인스턴스 객체 저장용
        isSwiper: false, // 배너 갯수가 2개 이상인 경우 swiper 처리를 위한 값
        activeIndex: 1,
        // 스와이퍼 옵션
        option: {
          slidesPerView: this.slidesPerView,
          slidesPerGroup: this.slidesPerView,
          spaceBetween: this.slidesPerView === 1 ? 0 : 20,
          loop: false,
          navigation: {
            prevEl: `#banner_${this.bannerId} .swiper-button-prev`,
            nextEl: `#banner_${this.bannerId} .swiper-button-next`
          },
          breakpoints: {
            1200: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 0,
              loop: true
            }
          },
          on: {
            init: () => {
              this.setActiveIndex()
              this.setControlColor()
            },
            slideChange: () => {
              this.setActiveIndex()
              this.setControlColor()
            }
          }
        }
      }
    }
  },
  computed: {
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    shouldShowSwiperNav () {
      if (this.slidesPerView === 1) {
        return this.bannerData.length > 1
      } else if (this.slidesPerView === 2) {
        return this.bannerData.length > 2
      }
      return false
    }
  },
  watch: {
    isDesktop (newVal, oldVal) {
      if (newVal !== oldVal) {
        // 스와이퍼 옵션 초기화
        this.destroySwiper()
        this.initSwiper()
      }
    }
  },
  mounted () {
    this.getBannerData() // 배너 데이터 설정
    this.addEvt()
  },
  beforeDestroy () {
    this.destroySwiper()
    this.removeEvt()
  },
  methods: {
    // 특정 엘리먼트의 부모 클래스가 일치하는지 여부 확인
    checkParent (parentClass, target) {
      let node = target.parentNode
      while (node != null) {
        if (node.classList.contains(parentClass)) {
          return true
        }
        node = node.parentNode
      }
      return false
    },
    addEvt () {
      this.$nextTick(() => {
        const bannerId = this.idPrefix + this.bannerId
        const bannerWrapper = document.querySelector(`#${bannerId}`)
        const bannerBtnWrapper = document.querySelector(`#${bannerId} .swiper_nav`)

        // click 이벤트 핸들러
        const handleClick = (e) => {
          const target = e.target

          if (bannerWrapper.contains(target) && !bannerBtnWrapper.contains(target)) {
            if (target.classList.contains('banner_link') || this.checkParent('banner_link', target)) {
              const bannerList = target.closest('.banner_list')
              const index = bannerList.getAttribute('data-swiper-slide-index')
              console.log('Clicked banner index:', index)

              // 중복 클릭 방지
              const item = this.bannerData[index]
              if (item && item.bannUrl) {
                this.goPotltLink(item)
              }
            }
          }
        }

        // 이전 이벤트 리스너 제거
        this.removeEvt = () => {
          window.removeEventListener('click', handleClick)
        }

        // 새로운 이벤트 리스너 추가
        window.addEventListener('click', handleClick)
      })
    },
    removeEvt () {
      window.removeEventListener('click', this.addEvt)
    },
    // 배너 데이터 설정
    getBannerData () {
      if (this.potltInfo && this.potltInfo.potltData) {
        this.bannerData = this.potltInfo.potltData.map((item) => ({
          title: item.bannNm,
          imgPc: `/mrm/v1/ignore/attach/image/${item.imgAttchFileId}/${item.imgFileId}`,
          imgMo: `/mrm/v1/ignore/attach/image/${item.mobImgAttchFileId}/${item.mobImgFileId}`,
          bgColorCd: item.bgColorCd,
          bannUrl: item.bannUrl,
          genLinkScCd: item.genLinkScCd
        }))

        if (this.bannerData.length > 1) {
          this.swiper.isSwiper = true
        }

        this.initSwiper()
      }
    },
    // 배너 갯수가 1개 이상인 경우 배너 스와이퍼 설정
    initSwiper () {
      this.$nextTick(() => {
        if (this.swiper.isSwiper) {
          const swiperContainer = this.$refs.mmpMainBanner

          // 스와이퍼 인스턴스 초기화
          this.swiper.instance = new Swiper(swiperContainer, this.swiper.option)

          // 스와이퍼 업데이트
          this.swiper.instance.update()
        }
      })
    },
    // 스와이퍼를 초기화하기 전 data-swiper-slide-index 값을 저장
    destroySwiper () {
      const swiperInstance = this.swiper.instance
      if (swiperInstance) {
        // 스와이퍼 인스턴스 제거 전에 data-swiper-slide-index 저장
        this.saveSlideIndexes()

        // 현재 활성 슬라이드 인덱스 저장
        this.swiper.activeIndex = swiperInstance.activeIndex

        // 스와이퍼 인스턴스 제거
        swiperInstance.destroy()
        this.swiper.instance = null

        // data-swiper-slide-index 복원
        this.restoreSlideIndexes()
      }
    },
    saveSlideIndexes () {
      this.slideIndexes = []
      const slides = document.querySelectorAll('.swiper-slide')
      slides.forEach(slide => {
        this.slideIndexes.push({
          element: slide,
          index: slide.getAttribute('data-swiper-slide-index')
        })
      })
    },
    restoreSlideIndexes () {
      this.slideIndexes.forEach(item => {
        if (item.element) {
          item.element.setAttribute('data-swiper-slide-index', item.index)
        }
      })
    },
    // swiper activeIndex 설정
    setActiveIndex () {
      this.$nextTick(() => {
        const swiperInstance = this.swiper.instance

        if (swiperInstance) {
          this.swiper.activeIndex = swiperInstance.realIndex + 1
        }
      })
    },
    // 현재 활성 스와이퍼의 bg 컬러 기준으로 컨트롤러 색상 설정
    setControlColor () {
      this.$nextTick(() => {
        const swiperInstance = this.swiper.instance

        if (swiperInstance) {
          const swiperContainer = this.$refs.mmpMainBanner
          const activeIdx = this.swiper.activeIndex
          const swiperNav = this.$refs.swiperNavigation
          const activeSlide = swiperContainer.querySelector(`.swiper-slide:nth-child(${activeIdx})`)

          if (activeSlide && swiperNav) {
            if (activeSlide.classList.contains('light_bg')) {
              // 컨트롤러 배경색상 밝게
              swiperNav.classList.remove('dark')
            } else {
              // 컨트롤러 배경색상 어둡게
              swiperNav.classList.add('dark')
            }
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/BandBanner.vue